<form [formGroup]="form" novalidate>
   <div class="mb-3">
      <label for="routingNumber" class="form-label fw-bold">Routing Number</label>
      <input id="routingNumber"
             type="text"
             class="form-control"
             formControlName="routingNumber"
             inputmode="numeric"
             maxlength="9"
             autocomplete="off" />
      @if (form.get('routingNumber')?.touched && form.get('routingNumber')?.invalid) {
         <em class="error-msg-block">Enter a valid 9-digit routing number.</em>
      }
   </div>

   <div class="mb-3">
      <label for="accountNumber" class="form-label fw-bold">Account Number</label>
      <input id="accountNumber"
             type="text"
             class="form-control"
             formControlName="accountNumber"
             inputmode="numeric"
             maxlength="17"
             autocomplete="off" />
      @if (form.get('accountNumber')?.touched && form.get('accountNumber')?.invalid) {
         <em class="error-msg-block">Enter a valid account number (4-17 digits).</em>
      }
   </div>

   <div class="mb-3">
      <label for="accountHolderName" class="form-label fw-bold">Account Holder Name</label>
      <input id="accountHolderName"
             type="text"
             class="form-control"
             formControlName="accountHolderName"
             maxlength="100"
             autocomplete="off" />
      @if (form.get('accountHolderName')?.touched && form.get('accountHolderName')?.invalid) {
         <em class="error-msg-block">Enter the account holder name.</em>
      }
   </div>

   <div class="mb-3">
      <label class="form-label fw-bold d-block">Account Type</label>
      <div class="btn-group" role="group" aria-label="Account type">
         @for (type of accountTypes; track type.code) {
            <input type="radio"
                   class="btn-check"
                   [id]="'accountType-' + type.code"
                   formControlName="accountTypeCode"
                   [value]="type.code" />
            <label class="btn btn-outline-primary" [for]="'accountType-' + type.code">
               {{ type.description }}
            </label>
         }
      </div>
   </div>
</form>
